import { useSelector, useDispatch } from 'react-redux';
import {
  setSuppliers,
  setSelectedSupplier,
  setSelectedEntity,
  setLoading,
  setError,
  clearEntity,
} from '../actions/reduxActions';
import { getCompanySuppliersAction } from '../actions/action';

export const useEntityState = () => {
  const dispatch = useDispatch();
  const entityState = useSelector((state) => state.entityReducer);

  const fetchSuppliers = async (module = 'default', params = {}) => {
    try {
      dispatch(setLoading(true));
      const { data, error, message } = await getCompanySuppliersAction(module, params);
      
      if (!error && data) {
        const suppliersList = Array.isArray(data) 
          ? data.flatMap((item) => item.suppliers_list || []) 
          : [];
        dispatch(setSuppliers(suppliersList));
      } else {
        dispatch(setError(message || 'Failed to fetch suppliers'));
      }
    } catch (err) {
      dispatch(setError(err.message || 'An error occurred'));
    }
  };

  const selectSupplier = (supplierId) => {
    dispatch(setSelectedSupplier(supplierId));
  };

  const selectEntity = (entityId) => {
    dispatch(setSelectedEntity(entityId));
  };

  const clear = () => {
    dispatch(clearEntity());
  };

  return {
    ...entityState,
    fetchSuppliers,
    selectSupplier,
    selectEntity,
    clear,
  };
};